var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsGuestInfant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeOpacity: 0.01,
    strokeWidth: 0.01,
    d: "M0 0h24v24H0V0z",
    transform: "translate(-375 -1820) translate(0 1161) translate(341 647) translate(34 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F1015",
    d: "M15.975 8.5c.018-1.125-.671-1.5-1.5-1.5-.828 0-1.481.375-1.499 1.5-.018 1.125.671 1.5 1.5 1.5.828 0 1.482-.375 1.5-1.5zm.027 4.5c1.103 0 2.243.858 2.55 1.931L19 18h-2l-.371-2.52c-.061-.212-.415-.48-.627-.48h-3.004c-.213 0-.566.268-.627.48L12 18h-2l.448-3.069c.305-1.066 1.439-1.931 2.55-1.931zM7 9v2h2v2H7v2H5v-2H3v-2h2V9h2zm7.476-4c1.933 0 3.52.875 3.5 3.5-.021 2.625-1.567 3.5-3.5 3.5s-3.52-.875-3.5-3.5c.021-2.625 1.567-3.5 3.5-3.5z",
    transform: "translate(-375 -1820) translate(0 1161) translate(341 647) translate(34 12)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGuestInfant);
export default __webpack_public_path__ + "static/media/icons-guest-infant.35e324f4c465d7e88c54602d8d90d9ea.svg";
export { ForwardRef as ReactComponent };